export const timelinesteps = () => [
  {
    target: '[data-tour="timeline-search"]',
    title: 'Search',
    content:
      'Search for epics and work items displayed on the timeline.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="timeline-filters"]',
    title: 'Filters',
    content:
      'Filter the timeline using assignee, status, issue type and epic.',
       disableBeacon: true,
  },
  {
    target: '[data-tour="timeline-grid"]',
    title: 'Timeline',
    content:
      'View project schedules and track work items across the calendar.',
       disableBeacon: true,
  },
  {
    target: '[data-tour="timeline-view"]',
    title: 'Timeline View',
    content:
      'Switch between Weekly, Monthly and Quarterly timeline views.',
       disableBeacon: true,
  },
];